import React, { useState, useEffect } from "react";
import emailjs from "emailjs-com"; // Updated import for emailjs-com
import M from "materialize-css";

export default function Form() {
  const [inputFirstName, setInputFirstName] = useState("");
  const [inputLastName, setInputLastName] = useState("");
  const [inputEmail, setInputEmail] = useState("");
  const [inputPhone, setInputPhone] = useState("");
  const [userInsuranceType, setUserInsuranceType] = useState("");
  const [userProcedureType, setUserProcedureType] = useState("");
  const [userMessage, setUserMessage] = useState("");

  // Handle form submit
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    // Basic validation to make sure all fields are filled
    if (
      !inputFirstName ||
      !inputLastName ||
      !inputEmail ||
      !inputPhone ||
      !userInsuranceType ||
      !userProcedureType
    ) {
      alert("Please fill out all fields.");
      return;
    }

    const emailParams = {
      userFirstname: inputFirstName,
      userLastname: inputLastName,
      userEmail: inputEmail,
      userPhone: inputPhone,
      userInsuranceType: userInsuranceType,
      userProcedureType: userProcedureType,
      userMessage: userMessage,
    };

    // Send the email with the form data
    emailjs
      .send(
        "service_sylfva6", // Replace with your Service ID
        "template_zg6o8e8", // Replace with your Template ID
        emailParams,
        "43Pwn_Ki0Yy_5yqmE" // Replace with your Public Key
      )
      .then(
        (response) => {
          console.log("Email successfully sent:", response);
          alert("Your message has been sent!");
        },
        (error) => {
          console.log("Failed to send email:", error);
          alert("Something went wrong. Please try again later.");
        }
      );
  };

  useEffect(() => {
    const elems = document.querySelectorAll("input#input_text, textarea#textarea2");
    if (window.M) {
      window.M.CharacterCounter.init(elems);
    }
  }, []);

  useEffect(() => {
    const selectElems = document.querySelectorAll("select");
    const selectInstances = M.FormSelect.init(selectElems);

    return () => {
      selectInstances.forEach((instance) => instance.destroy());
    };
  }, []);

  return (
    <div className="row form">
      <div className="col s10 offset-s1 center">
        <div className="col l5 12 left-align">
          <h4>Reduce Pain and Regain Mobility Fast</h4>
          <span style={{ fontSize: "20px" }}>
            Fill in the form to be contacted by Dr. Jennifer Mutch within days
          </span>
        </div>
        <div className="col l5 s12">
          <form onSubmit={handleFormSubmit}>
            <div className="input-field">
              <input
                name="userFirstname"
                id="Fname"
                type="text"
                className="validate"
                value={inputFirstName}
                onChange={(e) => setInputFirstName(e.target.value)}
              />
              <label htmlFor="Fname">First Name</label>
            </div>

            <div className="input-field">
              <input
                name="userLastname"
                id="Lname"
                type="text"
                className="validate"
                value={inputLastName}
                onChange={(e) => setInputLastName(e.target.value)}
              />
              <label htmlFor="Lname">Last Name</label>
            </div>

            <div className="input-field">
              <input
                name="userEmail"
                id="email"
                type="email"
                className="validate"
                value={inputEmail}
                onChange={(e) => setInputEmail(e.target.value)}
              />
              <label htmlFor="email">Email</label>
            </div>

            <div className="input-field">
              <input
                name="userPhone"
                id="phone"
                type="tel"
                className="validate"
                value={inputPhone}
                onChange={(e) => setInputPhone(e.target.value)}
              />
              <label htmlFor="phone">Phone</label>
            </div>

            <div className="input-field col s12">
              <select
                name="userInsuranceType"
                id="insuranceType"
                value={userInsuranceType}
                onChange={(e) => setUserInsuranceType(e.target.value)}
              >
                <option value="" disabled>
                  Choose your option
                </option>
                <option value="Quebec Insurance">Quebec Insurance</option>
                <option value="Public Insurance">Public Insurance</option>
                <option value="Other...">Other...</option>
              </select>
              <label htmlFor="insuranceType">Please select your insurance type</label>
            </div>

            <div className="input-field col s12">
              <select
                name="userProcedureType"
                id="procedureType"
                value={userProcedureType}
                onChange={(e) => setUserProcedureType(e.target.value)}
              >
                <option value="" disabled>
                  Choose your option
                </option>
                <option value="Knee Replacement (Partial or Total)">Knee Replacement (Partial or Total)</option>
                <option value="Hip Procedure (Partial or Total)">Hip Procedure (Partial or Total)</option>
                <option value="Shoulder Procedure (Reverse or Total)">Shoulder Procedure (Reverse or Total)</option>
              </select>
              <label htmlFor="procedureType">Please select your procedure type</label>
            </div>

            <div className="input-field col s12">
              <textarea
                id="textarea2"
                className="materialize-textarea"
                data-length="120"
                name="userMessage"
                value={userMessage}
                onChange={(e) => setUserMessage(e.target.value)}
              ></textarea>
              <label htmlFor="textarea2">Write your message here...</label>
            </div>

            <button className="btn waves-effect waves-light" type="submit" name="action">
              Submit
              <i className="material-icons right">send</i>
            </button>
          </form>
           <div className="helper-text" style={{ marginTop: "20px" }}>
            <p>
              Do you have x-ray images? <a href="mailto:j.mutch.ortho@gmail.com?subject=X-ray Images">Click here... OR email j.mutch.ortho@gmail.com </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
